import Service from "../Service";

const Common = {
  getImageLanding() {
    return Service.get("api/get-landing-image").then((res) => res);
  },
  getMainImageLanding() {
    return Service.get("api/get-main-landing-image").then((res) => res);
  },
  getGroupCategory() {
    return Service.get("api/get-group-cate").then((res) => res);
  },
};

export default Common;
